import script from "./VSelectWrapper.vue?vue&type=script&lang=js"
export * from "./VSelectWrapper.vue?vue&type=script&lang=js"

import "./VSelectWrapper.vue?vue&type=style&index=0&id=aaa1018c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/ui-components/VSelectWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aaa1018c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aaa1018c', __exports__)) {
    api.reload('aaa1018c', __exports__)
  }
  
}


export default __exports__